var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{style:({ width: _vm.width, height: _vm.height }),attrs:{"id":_vm.chartsId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }